module.exports = __webpack_public_path__ + "static/media/arr.f705bd1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arr.svg
// module id = 2344
// module chunks = 0